import React from 'react';        
import Button from '../../UI/Button/Button';
import Modal from '../../UI/Modal/Modal';
import  './InviteCollaborator.css';
import searchIcon from '../../../assets/images/search.svg';
import warningCollaboratorIcon from '../../../assets/images/warning.svg';
import AutoSuggestion from '../../UI/AutoSuggestion/AutoSuggestion';
import ProfileImage from '../../UI/ProfileImage/ProfileImage';
import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

const InviteCollaborator = (props) => {
  //ConsoleLog("collaborators",props.collaborators,props.adddedCollaborators,props.deletedCollaborators);
    return(
      <Modal show={props.show===true} onHide="" className="addCollaboratorModal-modal" backdropClassName="collaborator-backdrop">
        <div className="colla-search-box">
          <div className="modal-heading">Invite a collaborator to '<strong>{props.jobTitle} {props.jobBH}</strong>'</div>
            <AutoSuggestion
              icon={searchIcon}
              value={props.collaboratorSearchParam}
              onChange={props.collaboratorSearchHandler} 
              className="collaborator-search"
              placeholder="First name, Last name or Email address"
              autoSuggestionResults={props.collaboratorSearchResults}
              handleClick={props.onSelectCollaborator}
              hideNoResults={true}
              closeSuggestion={props.closeSuggestion}
              hideSuggestion={true}
            />
        </div>
        {props.collaboratorSearchParam !== "" && props.collaboratorSearchResults.length===0?
          <div className="no-collaborators-found">
          <img className="warning-collaborator-icon" src={warningCollaboratorIcon}/>
          <p className="not-found-title">User not found</p>
          <p className="not-found-desc">Please try again or contact your administrator to add a new member</p>
          </div>
        :props.collaboratorSearchParam !== "" &&props.collaboratorSearchResults.length===0?
            <div className="no-collaborators-found">
            <img className="warning-collaborator-icon" src={warningCollaboratorIcon}/>
            <p className="not-found-title">User not found</p>
            <p className="not-found-desc">Please try again or contact your administrator to add a new member</p>
            </div>
          : props.collaborators.filter(collaborator => (collaborator.userId != props.ownerUserId)).length ===0?
            <div className="no-collaborators-text" >
              <label className="no-collaborators">You have no collaborators yet</label><br/>
              <label className="no-collaborators-content">Enter a first name, last name or email address to start adding!</label>
            </div>:
            <div className="added-collaborators">
            <ul>
            {props.collaborators.filter(collaborator => (collaborator.userId != props.ownerUserId)).map((collaborators)=>
              <li>
                <ProfileImage 
                  className="added-collaborator-image" 
                  imageUrl={collaborators.imageUrl} 
                  initials={collaborators.initials}
                />
                <div className="collaborator-name-wrapper">
                  <div className="added-collaborator-name">
                    {collaborators.firstName+" "+collaborators.lastName}
                  </div>  
                  <span className="added-collaborator-email">{collaborators.email}</span>              
                </div>                
                <div className="added-collaborator-delete" onClick={()=>props.deleteCollaborator(collaborators.userId)}></div>                
              </li>
            )}
            </ul>
           </div>
        }
        <div className="modal-buttons">
          <Button 
            uistyle="lesser" 
            className="cancel-cancel" 
            onClick={props.cancelAddCollaborator}>Cancel</Button> 
          <Button 
            disabled={(props.adddedCollaborators.length >0 || props.deletedCollaborators.length > 0) ? false : true }  
            uistyle="primary" 
            className="button-update"  
            onClick={props.updateCollaborator}>Update</Button>
        </div>
      </Modal>
    )
}

export default InviteCollaborator;


// WEBPACK FOOTER //
// ./src/components/Recruiter/InviteCollaborator/InviteCollaborator.js